import { render, staticRenderFns } from "./hot_search.vue?vue&type=template&id=f6b6fccc&scoped=true"
import script from "./hot_search.vue?vue&type=script&lang=js"
export * from "./hot_search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b6fccc",
  null
  
)

export default component.exports